import React, {useState} from 'react';
import {CSVLink} from 'react-csv';

const ExportCSVData = ({data, filename, headers}) => {
    const [csvData, setCSVData] = useState([]);

    const handleExport = () => {
        setCSVData(data);
    };

    return (
        <div>
            <CSVLink data={csvData} headers={headers} filename={filename}>
                <button onClick={handleExport}
                        className={'button-sky px-2 py-1 flex justify-center items-center'}>
                    <div className={'mx-1'}>Download Pinterest CSV File</div>
                    <div
                        className={'border border-sky-700 bg-gray-50 text-sky-700 rounded-full font-semibold px-3 py-0 mx-1'}>
                        {data?.length}</div>
                </button>
            </CSVLink>
        </div>
    );
};

export default ExportCSVData;
